import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { saveAs } from 'file-saver';

import { Credentials } from '../../../shared/classes/credentials';
import { CrudService } from '../../crud.service';
import { interval } from 'rxjs';

@Component({
  styleUrls: ['./create-credentials-dialog.component.scss'],
  templateUrl: './create-credentials-dialog.component.html',
  standalone: false
})
export class CreateCredentialsDialogComponent implements OnInit {
  private readonly crudService = inject(CrudService);
  private readonly dialogRef = inject<MatDialogRef<CreateCredentialsDialogComponent>>(MatDialogRef);

  public static readonly CSV_FILE_NAME = 'IDC_Credentials.csv';
  public readonly saveAs = saveAs;
  public readonly keyIdLabel = 'IDC Key ID';
  public readonly keySecretLabel = 'IDC Key Secret';
  public keyIdButtonText = 'Copy';
  public keySecretButtonText = 'Copy';
  public credentials: Credentials = null;
  public isSecretVisible = false;

  public download(): void {
    const csvBlob = new Blob([
      [
        [ this.keyIdLabel, this.keySecretLabel ].join(','),
        [ this.credentials.accessKeyId, this.credentials.accessKeySecret ].join(',')
      ].join('\r\n'),
    ], { type: 'text/csv' });
    this.saveAs(csvBlob, CreateCredentialsDialogComponent.CSV_FILE_NAME);
  }

  public ngOnInit(): void {
    this.crudService.createCredentials(new Credentials()).subscribe(credentials => {
      this.credentials = credentials;
    });
  }

  public onDoneClick(): void {
    this.dialogRef.close();
  }

  public toggleSecretVisibility(): void {
    this.isSecretVisible = !this.isSecretVisible;
  }

  public copyId() {
    this.keyIdButtonText = 'Copied';
    window.navigator.clipboard.writeText(this.credentials.accessKeyId);
    interval(2000).subscribe(() => {
      this.keyIdButtonText = 'Copy';
    });
  }

  public copySecret() {
    this.keySecretButtonText = 'Copied';
    window.navigator.clipboard.writeText(this.credentials.accessKeySecret);
    interval(2000).subscribe(() => {
      this.keySecretButtonText = 'Copy';
    });
  }
}
